import { render, staticRenderFns } from "./FlightEvent.vue?vue&type=template&id=90844d40&scoped=true&"
import script from "./FlightEvent.vue?vue&type=script&lang=js&"
export * from "./FlightEvent.vue?vue&type=script&lang=js&"
import style0 from "./FlightEvent.vue?vue&type=style&index=0&id=90844d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90844d40",
  null
  
)

export default component.exports